import { ConfigCatKeys } from "common/constant/featureConfig";

// Example of overriding a feature flag locally
// featureFlagName: true, => SHOW_LATEST_NEWS: false
export const localOverrides: Partial<ConfigCatKeys> = {};
